var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmartphone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M17,1 L7,1 C5.34314575,1 4,2.34314575 4,4 L4,20 C4,21.6568542 5.34314575,23 7,23 L17,23 C18.6568542,23 20,21.6568542 20,20 L20,4 C20,2.34314575 18.6568542,1 17,1 Z M17,3 C17.5522847,3 18,3.44771525 18,4 L18,20 C18,20.5522847 17.5522847,21 17,21 L7,21 C6.44771525,21 6,20.5522847 6,20 L6,4 C6,3.44771525 6.44771525,3 7,3 L17,3 Z M12.7071068,17.2928932 C12.3165825,16.9023689 11.6834175,16.9023689 11.2928932,17.2928932 C10.9023689,17.6834175 10.9023689,18.3165825 11.2928932,18.7071068 C11.6834175,19.0976311 12.3165825,19.0976311 12.7071068,18.7071068 C13.0976311,18.3165825 13.0976311,17.6834175 12.7071068,17.2928932 Z",
    id: "path-smartphone"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/24/smartphone",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-smartphone",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-smartphone"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-smartphone"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-smartphone)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphone);
export default __webpack_public_path__ + "static/media/smartphone.80a638ee3bed111e3cb7dd32126e9388.svg";
export { ForwardRef as ReactComponent };